
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locaties",
      function () {
        return require("private-next-pages/locaties.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locaties"])
      });
    }
  